/**
 * Intercepteur de session : rejoue automatiquement une requete refusee pour
 * cause de jeton expire, apres avoir demande un nouveau jeton d'acces.
 *
 * Le refresh_token (cookie httpOnly, longue duree) permet de regenerer un
 * access_token (courte duree) de facon transparente. Sans ce mecanisme, la
 * duree de vie courte du jeton — voulue pour la securite — se traduit par une
 * deconnexion en pleine saisie (etat "zombie" : l'UI se croit connectee, le
 * serveur refuse).
 */
import axios from 'axios';
import { clearLoggedIn, clearCsrfToken } from './authState';

const API_URL = process.env.REACT_APP_BACKEND_URL;

let refreshPromise = null;

const doRefresh = () => {
  if (!refreshPromise) {
    refreshPromise = axios
      .post(`${API_URL}/api/auth/refresh`, {}, { withCredentials: true })
      .finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
};

export const installAuthInterceptor = (instance = axios) => {
  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const original = error.config;
      const status = error.response?.status;

      if (
        status !== 401 ||
        !original ||
        original._retried ||
        (original.url && original.url.includes('/api/auth/refresh')) ||
        (original.url && original.url.includes('/api/auth/login'))
      ) {
        return Promise.reject(error);
      }

      original._retried = true;

      try {
        await doRefresh();
        return instance(original);
      } catch (refreshError) {
        clearLoggedIn();
        clearCsrfToken();
        if (!window.location.pathname.startsWith('/login')) {
          window.location.href = '/login?expired=1';
        }
        return Promise.reject(refreshError);
      }
    }
  );
};
